/**
 * The grid for the Locations, Projects, Portfolios and Evaluations card views
 * (MYD-531). One string so the four screens cannot drift apart.
 *
 * At most 4 across, then 3, 2 and 1 as the space narrows, and a card is never
 * narrower than 280px: each column's minimum is the LARGER of 280px and a
 * quarter of the row (less the three 1rem gaps). The quarter term caps the row
 * at 4; the 280px term drops a column before a card gets cramped. Same rule and
 * same 280px floor as the home asset cards (MYD-530).
 *
 * Kept as a whole literal, not assembled, so Tailwind's scanner sees the class.
 */
export const CARD_GRID_CLASS = 'grid gap-4 grid-cols-[repeat(auto-fill,minmax(max(280px,calc((100%_-_3rem)/4)),1fr))]'
